<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">{{ getIconeFromCode(data.code) }}</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="openModifyTolerancePopin()">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li><strong translate="admin.frais.tolerances.tooltip.actif"></strong> {{ 'global.' + (data.active ? 'oui' : 'non') | translate }} </li>
            <li *ngIf="data.tolerance"><strong translate="admin.frais.tolerances.tooltip.tolerancePourcentage"></strong> {{ getToleranceFormatted() }} </li>
            <li *ngIf="data.toleranceMontant"><strong translate="admin.frais.tolerances.tooltip.toleranceMontant"></strong> {{ data.toleranceMontant | number:'1.2-2' }} EUR </li>
        </ul>
    </div>
</div>
